/**
 * Display names for SubsidiaryInvoice.Status on Hotel health check Billing.
 * Must match the Balance state column labels in the Billing table.
 */
export const healthCheckBillingInvoiceStatusLabels = {
  Paid: 'Paid',
  PaidPartially: 'Partial paid',
  PaymentPending: 'Payment pending',
  ReviewPending: 'Planned',
  ReviewCompleted: 'Planned',
  PaymentFailed: 'Payment failed',
  PaymentOverdue: 'Payment overdue',
  MonthInProgress: 'Month in progress',
  MonthSkipped: 'Month skipped',
  Unknown: 'Unknown'
}

/**
 * Invoice statuses that can appear on this page (open invoices only).
 * Paid and MonthSkipped are excluded by the billing health-check query.
 */
export const healthCheckBillingInvoiceStatusFilterOptions = {
  Unknown: healthCheckBillingInvoiceStatusLabels.Unknown,
  MonthInProgress: healthCheckBillingInvoiceStatusLabels.MonthInProgress,
  ReviewPending: healthCheckBillingInvoiceStatusLabels.ReviewPending,
  ReviewCompleted: healthCheckBillingInvoiceStatusLabels.ReviewCompleted,
  PaymentPending: healthCheckBillingInvoiceStatusLabels.PaymentPending,
  PaymentFailed: healthCheckBillingInvoiceStatusLabels.PaymentFailed,
  PaymentOverdue: healthCheckBillingInvoiceStatusLabels.PaymentOverdue,
  PaidPartially: healthCheckBillingInvoiceStatusLabels.PaidPartially
}

export const defaultHealthCheckBillingInvoiceStatuses = Object.keys(
  healthCheckBillingInvoiceStatusFilterOptions
)
